// src/features/products/productsApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Urls from "../../components/Url/Urls";


export const movementApi = createApi({
  reducerPath: 'movementApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.order.get }),
  tagTypes: ['movementApi'],
  endpoints: (builder) => ({
    getMovements: builder.query({
      query: () => "GetStockMovement",
      keepUnusedDataFor: 35,
      providesTags: ['movementApi'], 
      invalidatesTags: ['movementApi'], 
    }),
    createMovement: builder.mutation({
      query: (newMovement) => {
        delete newMovement.productName;
        delete newMovement.supplierName;
        delete newMovement.supplierId;
        delete newMovement.consumerId;
        delete newMovement.quantity;
        return {
          url: Urls.order.post,
          method: 'POST',
          body: newMovement,
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['movementApi'], 
    }),
    updateMovement: builder.mutation({
      query: (movementData) => {
      
        return {
          url: Urls.order.update + movementData.Id,
          method: 'PUT',
          body: movementData,
          
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['movementApi'],
    }),
  
    DeleteOrderedProduct: builder.mutation({
      query: (Id) => ({
        url: Urls.order.delete + Id,
        method: 'DELETE',
      }),
      invalidatesTags: ['movementApi'], 
    }),

  }),
  keepUnusedDataFor: 1
});


export const productOrderApi = createApi({
  reducerPath: 'productOrderApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.order.get }),
  tagTypes: ['productOrderApi'],
  endpoints: (builder) => ({

    createProductOrder: builder.mutation({
      query: (newMovement) => {
        delete newMovement.productName;
        delete newMovement.consumerName;
        return {
          url: Urls.order.create,
          method: 'POST',
          body: newMovement,
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['productOrderApi'], 
    }),
  }),
  keepUnusedDataFor: 1,
});


export const getLastGenIdsApi = createApi({
  reducerPath: 'getLastGenIdsApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.order.getLastGenId }),
  endpoints: (builder) => ({
    getLastGenId: builder.query({
      query: () => 'getLastGenId',
    })
  })
});


export const GetStockMovementReportApi = createApi({
  reducerPath: 'GetStockMovementReportApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.order.getLastGenId }),
  endpoints: (builder) => ({
    GetMovementReport: builder.query({
      query: () => 'GetStockMovementReport',
    })
  })
});









export const {
  useGetMovementsQuery,
  useCreateMovementMutation,
  useUpdateMovementMutation,
  useDeleteOrderedProductMutation,
} = movementApi;

export const {
  useCreateProductOrderMutation
} = productOrderApi

export const {
  useGetLastGenIdQuery
} = getLastGenIdsApi

export const {
  useGetMovementReportQuery
} = GetStockMovementReportApi
